import { LineData } from "lightweight-charts";

export class Averages
{
  public static computeSma(data: LineData[], period:number)
  {
     let newData: LineData[] = [];
  //    data = data.reverse();

     for(let i=0;i<data.length-period;i++)
     {

      if((i+period)>data.length)
      {
        return newData;//.reverse();
      }

       let d = data.slice(i,i+period);
       if(d.length==period)
       {
       const sum =  Averages.sumAverage(d,period);
       newData.push({time:data[i+period].time, value:sum})
       }
     }

    //  let df = data.map(v=>{
    //    return v.value
    //  });

    //  let k = this.sma(df, period);
     return newData//.reverse();
  }

  public static sumAverage(data:LineData[], period)
  {
    let sum = 0;
    data.forEach(element => {
      sum+=element.value
    });

    return sum/period;

  }


  public static sma(arr, range) {
    if (!Array.isArray(arr)) {
      throw TypeError('expected first argument to be an array');
    }


    var num = range || arr.length;
    var res = [];
    var len = arr.length + 1;
    var idx = num - 1;
    while (++idx < len) {
      res.push(this.avg(arr, idx, num));
    }
    return res;
  }


 public static sum(arr) {
    var len = arr.length;
    var num = 0;
    while (len--) num += Number(arr[len]);
    return num;
  }

  public static avg(arr, idx, range) {
    return this.sum(arr.slice(idx - range, idx)) / range;
  }


  public static averageOfAvailablePoints(data: LineData[], numOfPoints: number = 16): number {
    let pointsToCalculate = Math.min(numOfPoints, data.length);
  
    let sum = 0;
    for (let i = data.length - pointsToCalculate; i < data.length; i++) {
      sum += data[i].value;
    }
  
    return sum / pointsToCalculate;
  }
}
